import { render, staticRenderFns } from "./payAliResult.vue?vue&type=template&id=b928f772&scoped=true&"
import script from "./payAliResult.vue?vue&type=script&lang=js&"
export * from "./payAliResult.vue?vue&type=script&lang=js&"
import style0 from "./payAliResult.vue?vue&type=style&index=0&id=b928f772&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b928f772",
  null
  
)

component.options.__file = "payAliResult.vue"
export default component.exports